//React
import { FunctionComponent, useEffect } from "react";

//Components
import ResultList from "./result-list";
import NearbyCommunitiesResultList from "./result-list-nearby-communities";
import NearbyQmisResultList from "./result-list-nearby-qmis";
import AreaInfo from "../../../area-info/components/area-info";
import BreadCrumb from "./bread-crumb";
import AreaNewHomeCount from "../../../area-info/components/area-new-home-count";
import { useAppDispatch, useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";
import { selectIsMobile } from "../../../system/redux/selectors/select-is-mobile";
import { selectIsMobileCardOpen } from "../../../system/redux/selectors/select-is-mobile-card-open";
import { selectIsQmiFinder } from "../../../system/redux/selectors/select-is-qmi-finder";
import { selectIsFirstSearchComplete } from "../../../system/redux/selectors/select-first-search-complete";
import { setFirstSearchComplete } from "../../../system/redux/slices/app-status-slice";
import { setIsMobileCardOpen } from "../../../system/redux/slices/app-status-slice";
import { setSelectedResult } from "../../redux/slices/result-list-slice";
import { setIsQmiFinder } from "../../../system/redux/slices/app-status-slice";

import { selectRteApiData } from "../../redux/selectors/rte/select-rte-api-data";
import { selectAreaIsState } from "../../../area-info/redux/selectors/select-area-is-state";

interface ResultContainerProps {}

const ResultListContainer: FunctionComponent<ResultContainerProps> = (
	props,
) => {
	const dispatch = useAppDispatch();

	const isMobile = useAppSelector(selectIsMobile);
	const isQmiFinder = useAppSelector(selectIsQmiFinder);
	const isFirstSearchComplete = useAppSelector(selectIsFirstSearchComplete);
	const rteStatus = useAppSelector(selectRteApiData);
	const areaIsState = useAppSelector(selectAreaIsState);

	useEffect(() => {
        if (!isMobile) {
			dispatch(setIsMobileCardOpen(false));
			dispatch(setSelectedResult(null));
		}
    }, [isMobile]);
	
	const isMobileCardOpen = useAppSelector(selectIsMobileCardOpen);
	const mobileCardOpenStyling = {
		display: isMobileCardOpen ? 'none' : 'block',
	}

	const isCommunitySelected = isQmiFinder ? '' : 'selected';
	const isQmiSelected = isQmiFinder ? 'selected' : '';

	const handleTabClick = (tabValue: boolean) => {
		// only run functions if tab click is changing isQmiFinder's value
		if (tabValue !== isQmiFinder) {
			// reset the firstSearchComplete state to false
			// so it can be re-set to true when the related API finishes loading
			dispatch(setFirstSearchComplete(false));

			// set is QMI Finder to true or false
			dispatch(setIsQmiFinder(tabValue));
		}
	};

	//JSX
	return (
		<>
			{/* Do not show the breadcrumb on mobile */}
			{!isMobile && <BreadCrumb />}
			{isMobile && <AreaNewHomeCount />}
			<div className="community-set__tab-container" style={mobileCardOpenStyling}>
				{!isMobile && rteStatus.status !== "live" && isFirstSearchComplete &&
					<>
						{!areaIsState ? <div className="hotw-tabs">
							<button onClick={() => handleTabClick(false)} className={isCommunitySelected} id="communityTab">Communities</button>
							<button onClick={() => handleTabClick(true)} className={isQmiSelected} id="qmiTab">Homes of the week</button>
						</div> : <div className="hotw-tabs">
							<button onClick={() => handleTabClick(false)} className={isCommunitySelected} id="communityTab">Communities</button>
						</div>}
					</>
				}

				{isFirstSearchComplete && <>
					<ResultList />
					{!isQmiFinder ?
						<NearbyCommunitiesResultList /> :
						<NearbyQmisResultList />
					}
					
					<AreaInfo />
				</>}
			</div>
		</>
	);
};

export default ResultListContainer;
